import { ICamera, IClient, IProject } from '@api/models';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface AiServicedListProps {
    isLoading: boolean;
    cameras: ICamera[];
}

const AiServicedList = ({ isLoading, cameras }: AiServicedListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={cameras}
            columns={[{ header: 'Camera Name' }, { header: 'Client' }, { header: 'Project' }, { header: 'Created On' }]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/cameras/${row._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.client as IClient).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/project-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.project as IProject).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>{moment(row.createdAt).format('DD MMM YYYY, h:mm A')}</Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default AiServicedList;
